<template>
  <div class="vx-card mt-5 mb-5">
    <h1 class="card-bg p-6 text-center mb-4">PARA TRANSFERİ</h1>

    <!-- <div class="mt-5" style="width: 100%; font-size: 15px; position: ; left: 45%;">
      <div class="vx-row" style="margin-left: 5px;">
        <label> <b style="color: red;"> Kur Bilgileri </b></label>
      </div>
      <div :key="tr.id" v-for="(tr, i) in moneyCurrencyOptions" class="vx-row">
        <div class="vx-col" style="width: 80px;">
          <label>{{ tr.logo }} {{ tr }} </label>
        </div>
        <div class="vx-col">
          <input type="number" style="width: 99px;" v-model="tr.value" placeholder="Döviz" />
        </div>
      </div>
    </div> -->

    <div class="card-bg p-6 tFlex mobile-block gap-4" style="justify-content:center">
      <div :key="tr.id" v-for="(tr, i) in moneyCurrencyOptions" class="tFlex tFlex_ai-c gap-1">
        <template v-if="tr.id != 3">
          <p class="" style="font-size: 1.5rem;">{{ tr.logo }}</p>
          <!-- <p>{{ tr.value }}</p> -->
          <vs-input type="number" style="width: 99px;" class="p-1" v-model="tr.value" placeholder="Döviz" />
        </template>
      </div>
    </div>

    <div class="flex flex-wrap mt-5 mb-5 w-full" id="transactionDetail" name="transactionDetail" style="color: gray; font-size: 20px; justify-content: left; width: 40%;">
      {{ moneyTransferModel.owedAccountType == null ? "" : moneyTransferModel.owedAccountType }}
      {{ moneyTransferModel.owedCustomerId == null ? "" : moneyTransferModel.owedCustomerId + " Müşteri Nolu " }}
      {{ moneyTransferModel.owedAccountId == null ? "" : moneyTransferModel.owedAccountId + " " + moneyTransferModel.owedCurrencyName + " Hesabından " }}
      {{ moneyTransferModel.owedAccountCompanyId == null ? "" : moneyTransferModel.owedAccountId + " " + moneyTransferModel.owedAccountCompanyId + " Hesabından " }}

      {{ moneyTransferModel.owedToAccountType == null ? "" : moneyTransferModel.owedToAccountType }}
      {{ moneyTransferModel.owedToCustomerId == null ? "" : moneyTransferModel.owedToCustomerId + " Müşteri Nolu " }}
      {{ moneyTransferModel.owedToAccountId == null ? "" : moneyTransferModel.owedToAccountId + " " + moneyTransferModel.owedToCurrencyName + " Hesabına Yapılan  Transferin Muhasebe Kaydıdır." }}
      {{ moneyTransferModel.owedToAccountCompanyId == null ? "" : moneyTransferModel.owedToAccountId + " " + moneyTransferModel.owedToAccountCompanyId + " Hesabına Yapılan  Transferin Muhasebe Kaydıdır." }}

      {{
        moneyTransferModel.owedTransferAmount == null
          ? ""
          : moneyTransferModel.owedTransferAmount + " " + moneyTransferModel.owedCurrencyName + "------>" + moneyTransferModel.owedToTransferAmount + " " + moneyTransferModel.owedToCurrencyName + " Çapraz Kur --> " + moneyTransferModel.transferFxRate
      }}
    </div>
    <!-- <div class="flex flex-wrap mt-5" style="color: gray; font-size: 20px; justify-content: left;"></div> -->

    <div class="tFlex gap-6">
      <!-- BORÇ AYAĞI -->
      <div class="card-bg p-6 flex-1">
        <div class="flex flex-wrap mt-5" style="font-size: 20px; justify-content: center;">
          BORÇ HESABI
        </div>
        <div class="mt-5 vx-row" style="justify-content: center;">
          <input
            class="vs-radio"
            type="radio"
            @change="
              moneyTransferModel.owedAccountId = null;
              moneyTransferModel.owedCustomerId = null;
            "
            v-model="moneyTransferModel.owedAccountType"
            value="Customer"
          />
          <label class="mr-5 mt-1">Customer</label>

          <input
            class="vs-radio ml-5"
            type="radio"
            @change="
              moneyTransferModel.owedAccountId = null;
              moneyTransferModel.owedCustomerId = null;
            "
            v-model="moneyTransferModel.owedAccountType"
            value="Company"
          />
          <label class="mr-5 mt-1">Nitro Hesabı</label>
        </div>
        <!--  -->
        <!--  Borçlu Müşteri Search  -->
        <!--  -->

        <div v-if="moneyTransferModel.owedAccountType == 'Customer'">
          <label class="display-block mb-2">
            <b>Müşteri</b>
          </label>
          <div class="flex small-icon">
            <vs-input icon-pack="feather" icon="icon-user" style="width: 42%;" placeholder="Müşteri Ara" v-model="owedCustomerSearchQuery" @keyup="delayedSearch('OwedCustomer')" />
            <vs-button type="border" class="ml-5" @click="delayedSearch('OwedCustomer')">Ara</vs-button>
          </div>
          <div class="vx-row mt-10">
            <div class="vx-col md:w-1/2 w-full">
              <vs-table search :maxItems="10" :pagination="true" :data="owedCustomerSearchQueryResult">
                <template slot="thead">
                  <vs-th class="w-1/3">Müşteri</vs-th>
                  <vs-th class="w-1/6">Seç</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="tr.customerId" v-for="(tr, i) in data" class="pt-0 pb-1">
                    <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                      <b> {{ i + 1 + " . " }}</b> {{ tr.firstName.substr(0, 30) }}
                    </vs-td>

                    <td class="flex">
                      <input class="vs-radio" type="radio" v-model="moneyTransferModel.owedCustomerId" :value="tr.customerId" @change="getSelectedAccount('OwedCustomer')" />
                      <a :href="'/CustomerAccountWatch/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap Link</b></a>
                      <a :href="'/contactsView/' + tr.customerId" style="margin-left: 15px; margin-top: 5px;" target="_blank">Müşteri Link</a>
                      <feather-icon v-if="!tr.isReadyForInvoice && !tr.isOnlineCustomer" icon="AlertOctagonIcon" class="ml-2 kucukbuton" svgClasses="w-8 h-8 hover:text-primary danger" :title="tr.error" />
                    </td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <vs-table search noDataText="Veri bulunamadı" :data="owedCustomerAccountList">
                <vs-th class="w-3/12">Hesaplar</vs-th>
                <vs-th class="w-1/12">Bakiye</vs-th>
                <vs-th class="w-1/12">Döviz</vs-th>
                <vs-th class="w-1/12">Seç</vs-th>
                <vs-th class="w-1/12">HesapLink</vs-th>

                <vs-tr :key="tr.accountId" v-for="(tr, i) in owedCustomerAccountList" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountId }}
                  </vs-td>

                  <td>
                    <vs-input readonly="readonly" style="width: 105px;" v-model="tr.balance" />
                  </td>
                  <td>
                    <vs-input readonly="readonly" style="width: 55px;" v-model="tr.currencyName" />
                  </td>
                  <td>
                    <vs-radio
                      v-model="moneyTransferModel.owedAccountId"
                      @change="
                        () => {
                          moneyTransferModel.owedCurrencyId = tr.currencyId;
                          moneyTransferModel.owedCurrencyName = tr.currencyName;
                          moneyTransferModel.owedCurrencyFxRate = moneyCurrencyOptions.filter((r) => r.id == tr.currencyId).map((obj) => obj.value)[0];
                        }
                      "
                      :vs-value="tr.accountId"
                    />
                  </td>
                  <td>
                    <a :href="'/AccountMovementWatch/' + tr.accountId" style="margin-left: 15px; color:  #7393B3 ; font-size: 25px;" target="_blank"><b>...</b></a>
                  </td>
                </vs-tr>
              </vs-table>
            </div>
          </div>
        </div>

        <!--  -->
        <!-- Borçlu Kurum Hesabı Search  -->
        <!--  -->

        <div v-if="moneyTransferModel.owedAccountType == 'Company'">
          <label class="display-block mb-2">
            <b>Nitro Hesapları</b>
          </label>
          <div class="flex small-icon">
            <vs-input icon-pack="feather" icon="icon-user" style="width: 42%;" placeholder="Personel Ara" v-model="owedPersonnelSearchQuery" @keyup="delayedSearch('OwedPersonnel')" />
            <vs-button type="border" class="ml-5" @click="delayedSearch('OwedPersonnel')">Ara</vs-button>
          </div>
          <div class="vx-row mt-10">
            <div class="vx-col md:w-1/2 w-full">
              <vs-table search :data="owedPersonnelSearchQueryResult">
                <vs-th class="w-1/3">Personel</vs-th>
                <vs-th class="w-1/3">Seç</vs-th>

                <vs-tr :key="tr.customerId" v-for="(tr, i) in owedPersonnelSearchQueryResult" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.userName.substr(0, 30) }}
                  </vs-td>

                  <td class="flex">
                    <input class="vs-radio" type="radio" v-model="moneyTransferModel.owedUserId" :value="tr.userId" @change="getSelectedAccount('OwedPersonnel')" />
                    <a :href="'/userEdit/' + tr.userId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Personel Link</b></a>
                  </td>
                </vs-tr>
              </vs-table>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <vs-table search noDataText="Veri bulunamadı" :maxItems="10" :pagination="true" :data="owedAccountCompanyList">
                <template slot="thead">
                  <vs-th class="w-3/12">Hesaplar</vs-th>
                  <vs-th class="w-1/12">Bakiye</vs-th>
                  <vs-th class="w-1/12">Döviz</vs-th>
                  <vs-th class="w-1/12">Seç</vs-th>
                  <vs-th class="w-1/12">HesapLink</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                    <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                      <b> {{ i + 1 + " . " }}</b> {{ tr.accountId + " - " + tr.accountTypeName.substr(0, 20) }}
                    </vs-td>

                    <td>
                      <vs-input readonly="readonly" style="width: 95px;" v-model="tr.balance" />
                    </td>
                    <td>
                      <vs-input style="width: 55px;" readonly="readonly" v-model="tr.currencyName" />
                    </td>
                    <td>
                      <vs-radio
                        class=""
                        v-model="moneyTransferModel.owedAccountId"
                        @change="
                          () => {
                            moneyTransferModel.owedCurrencyId = tr.currencyId;
                            moneyTransferModel.owedCurrencyName = tr.currencyName;
                            moneyTransferModel.owedCurrencyFxRate = moneyCurrencyOptions.filter((r) => r.id == tr.currencyId).map((obj) => obj.value)[0];
                          }
                        "
                        :vs-value="tr.accountId"
                      />
                    </td>
                    <td>
                      <a :href="'/AccountCompanyMovementWatch/' + tr.accountId" style="margin-left: 15px; color:  #7393B3 ; font-size: 25px;" target="_blank"><b>...</b></a>
                    </td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>

      <!--  -->
      <!--  -->
      <!-- ALACAK AYAĞI -->
      <!--  -->
      <!--  -->

      <div class="card-bg p-6 flex-1">
        <div class="flex flex-wrap mt-5" style="font-size: 20px; justify-content: center;">
          ALACAK HESABI
        </div>

        <div class="mt-5 vx-row" style="justify-content: center;">
          <input
            class="vs-radio"
            type="radio"
            @change="
              moneyTransferModel.owedToAccountId = null;
              moneyTransferModel.owedToCustomerId = null;
            "
            v-model="moneyTransferModel.owedToAccountType"
            value="Customer"
          />
          <label class="mr-5 mt-1">Customer</label>

          <input
            class="vs-radio ml-5"
            type="radio"
            @change="
              moneyTransferModel.owedToAccountId = null;
              moneyTransferModel.owedToCustomerId = null;
            "
            v-model="moneyTransferModel.owedToAccountType"
            value="Company"
          />
          <label class="mr-5 mt-1">Nitro Hesabı</label>
        </div>
        <!--  -->
        <!--  Borçlu Müşteri Search  -->
        <!--  -->

        <div v-if="moneyTransferModel.owedToAccountType == 'Customer'">
          <label class="display-block mb-2">
            <b>Müşteri</b>
          </label>
          <div class="flex small-icon">
            <vs-input icon-pack="feather" icon="icon-user" style="width: 42%;" placeholder="Müşteri Ara" v-model="owedToCustomerSearchQuery" @keyup="delayedSearch('OwedToCustomer')" />
            <vs-button type="border" class="ml-5" @click="delayedSearch('OwedToCustomer')">Ara</vs-button>
          </div>
          <div class="vx-row mt-10">
            <div class="vx-col md:w-1/2 w-full">
              <vs-table search :maxItems="10" :pagination="true" :data="owedToCustomerSearchQueryResult">
                <template slot="thead">
                  <vs-th class="w-1/3">Müşteri</vs-th>
                  <vs-th class="w-1/6">Seç</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="tr.customerId" v-for="(tr, i) in data" class="pt-0 pb-1">
                    <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                      <b> {{ i + 1 + " . " }}</b> {{ tr.firstName.substr(0, 30) }}
                    </vs-td>

                    <td class="flex">
                      <input class="vs-radio" type="radio" v-model="moneyTransferModel.owedToCustomerId" :value="tr.customerId" @change="getSelectedAccount('OwedToCustomer')" />
                      <a :href="'/CustomerAccountWatch/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap Link</b></a>
                      <a :href="'/contactsView/' + tr.customerId" style="margin-left: 15px; margin-top: 5px;" target="_blank">Müşteri Link</a>
                      <feather-icon v-if="!tr.isReadyForInvoice && !tr.isOnlineCustomer" icon="AlertOctagonIcon" class="ml-2 kucukbuton" svgClasses="w-8 h-8 hover:text-primary danger" :title="tr.error" />
                    </td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <vs-table search :data="owedToCustomerAccountList">
                <vs-th class="w-3/12">Hesaplar</vs-th>
                <vs-th class="w-1/12">Bakiye</vs-th>
                <vs-th class="w-1/12">Döviz</vs-th>
                <vs-th class="w-1/12">Seç</vs-th>
                <vs-th class="w-1/12">HesapLink</vs-th>

                <vs-tr :key="tr.accountId" v-for="(tr, i) in owedToCustomerAccountList" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountId }}
                  </vs-td>

                  <td>
                    <vs-input readonly="readonly" style="width: 95px;" v-model="tr.balance"/>
                  </td>
                  <td>
                    <vs-input readonly="readonly" style="width: 55px;" v-model="tr.currencyName"/>
                  </td>
                  <td>
                    <vs-radio
                      class=""
                      v-model="moneyTransferModel.owedToAccountId"
                      @change="
                        () => {
                          moneyTransferModel.owedToCurrencyId = tr.currencyId;
                          moneyTransferModel.owedToCurrencyName = tr.currencyName;
                          moneyTransferModel.owedToCurrencyFxRate = moneyCurrencyOptions.filter((r) => r.id == tr.currencyId).map((obj) => obj.value)[0];
                        }
                      "
                      :vs-value="tr.accountId"
                    />
                  </td>
                  <td>
                    <a :href="'/AccountMovementWatch/' + tr.accountId" style="margin-left: 15px; color:  #7393B3 ; font-size: 25px;" target="_blank"><b>...</b></a>
                  </td>
                </vs-tr>
              </vs-table>
            </div>
          </div>
        </div>

        <!--  -->
        <!-- Alacaklı Kurum Hesabı Search  -->
        <!--  -->

        <div v-if="moneyTransferModel.owedToAccountType == 'Company'">
          <label class="display-block mb-2">
            <b>Nitro Hesapları</b>
          </label>
          <div class="flex small-icon">
            <vs-input icon-pack="feather" icon="icon-user" style="width: 42%;" placeholder="Personel Ara" v-model="owedToPersonnelSearchQuery" @keyup="delayedSearch('OwedToPersonnel')" />
            <vs-button type="border" class="ml-5" @click="delayedSearch('OwedToPersonnel')">Ara</vs-button>
          </div>
          <div class="vx-row mt-10">
            <div class="vx-col md:w-1/2 w-full">
              <vs-table :data="owedToPersonnelSearchQueryResult">
                <vs-th class="w-1/3">Personel</vs-th>
                <vs-th class="w-1/3">Seç</vs-th>

                <vs-tr :key="tr.customerId" v-for="(tr, i) in owedToPersonnelSearchQueryResult" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.userName.substr(0, 30) }}
                  </vs-td>

                  <td class="flex">
                    <input class="vs-radio" type="radio" v-model="moneyTransferModel.owedToUserId" :value="tr.userId" @change="getSelectedAccount('OwedToPersonnel')" />
                    <a :href="'/userEdit/' + tr.userId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Personel Link</b></a>
                  </td>
                </vs-tr>
              </vs-table>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <vs-table search :maxItems="10" :pagination="true" :data="owedToAccountCompanyList">
                <template slot="thead">
                  <vs-th class="w-3/12">Hesaplar</vs-th>
                  <vs-th class="w-1/12">Bakiye</vs-th>
                  <vs-th class="w-1/12">Döviz</vs-th>
                  <vs-th class="w-1/12">Seç</vs-th>
                  <vs-th class="w-1/12">HesapLink</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                    <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                      <b> {{ i + 1 + " . " }}</b> {{ tr.accountId + " - " + tr.accountTypeName.substr(0, 20) }}
                    </vs-td>

                    <td>
                      <vs-input readonly="readonly" style="width: 95px;" v-model="tr.balance" />
                    </td>
                    <td>
                      <vs-input style="width: 55px;" readonly="readonly" v-model="tr.currencyName" />
                    </td>
                    <td>
                      <vs-radio
                        class=""
                        v-model="moneyTransferModel.owedToAccountId"
                        @change="
                          () => {
                            moneyTransferModel.owedToCurrencyId = tr.currencyId;
                            moneyTransferModel.owedToCurrencyName = tr.currencyName;
                            moneyTransferModel.owedToCurrencyFxRate = moneyCurrencyOptions.filter((r) => r.id == tr.currencyId).map((obj) => obj.value)[0];
                          }
                        "
                        :vs-value="tr.accountId"
                      />
                    </td>
                    <td>
                      <a :href="'/AccountCompanyMovementWatch/' + tr.accountId" style="margin-left: 15px; color:  #7393B3 ; font-size: 25px;" target="_blank"><b>...</b></a>
                    </td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--MUHASEBE BİLGİLERİ  -->
    <!--  -->

    <div class="flex flex-wrap mt-5" style="color:  #7393B3 ; font-size: 30px; justify-content: center;">
      MUHASEBE BİLGİLERİ
    </div>

    <div class="mt-5" style="justify-content: center;" v-if="moneyTransferModel.owedCurrencyId && moneyTransferModel.owedToCurrencyId">
      <div class="vx-row" style="justify-content: center;" v-if="moneyTransferModel.owedCurrencyId != moneyTransferModel.owedToCurrencyId">
        <label style="color: red;"
          ><b
            >Hesaplar farklı döviz kurunda olduğu için çapraz kur çevrimi olacaktır. Çapraz kur oranı
            {{ (moneyTransferModel.transferFxRate = parseFloat(moneyTransferModel.owedCurrencyFxRate / moneyTransferModel.owedToCurrencyFxRate)) }}
          </b></label
        >
        <feather-icon icon="RefreshCwIcon" title="Yenile" svgClasses="h-5 mr-5 hover:text-danger cursor-pointer" @click="RefreshFxRate()" />
      </div>

      <div class="vx-row" style="justify-content: center;">
        <div class="vx-col mt-8">
          <label class=""><b>Tutar</b></label>
        </div>
        <div class="vx-col">
          {{ moneyTransferModel.owedCurrencyName }}
          <vs-input
            v-model="moneyTransferModel.owedTransferAmount"
            @input="moneyTransferModel.owedToTransferAmount = parseFloat(moneyTransferModel.transferFxRate * moneyTransferModel.owedTransferAmount).toFixed(2)"
            type="number"
            placeholder="Tutar"
          />
        </div>
        <div class="vx-col">
          {{ moneyTransferModel.owedToCurrencyName }}
          <vs-input
            v-model="moneyTransferModel.owedToTransferAmount"
            @input="moneyTransferModel.owedTransferAmount = parseFloat(moneyTransferModel.owedToTransferAmount / moneyTransferModel.transferFxRate).toFixed(2)"
            type="number"
            placeholder="Tutar"
          />
        </div>

        {{ moneyTransferModel.owedCurrencyId + " - " + moneyTransferModel.owedToCurrencyId }}
        <div class="vx-col mt-3" v-if="moneyTransferModel.owedCurrencyId && moneyTransferModel.owedToCurrencyId && moneyTransferModel.owedCurrencyId != moneyTransferModel.owedToCurrencyId">
          <div class="vx-row">
            <div class="vx-col mt-3"><b>Çapraz Kur</b></div>
            <div class="vx-col">
              <vs-input v-model="moneyTransferModel.transferFxRate" type="number" placeholder="Çapraz kuru oranı" />
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row" style="justify-content: center;">
        <div class="vx-col mt-12"><b>Fiş Açıklaması</b></div>
        <div class="vx-col mt-10">
          <vs-input style="width: 500px;" v-model="moneyTransferModel.transactionDescription" type="text" placeholder="Fiş Açıklamasını Giriniz" />
        </div>
      </div>
    </div>

    <div class="w-full mt-5 " style="text-align: center;margin-bottom:100px !important;" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '14') != null">
      <vs-button style="" @click="createTransaction()">Muhasebe Fişi Kes</vs-button>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

import { repository } from "@/_services/repository.js";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      moneyCurrencyOptions: [],
      moneyTransferModel: {
        owedCustomerId: null,
        owedToCustomerId: null,
        owedAccountType: null,
        owedAccountId: null,
        currencyId: null,
        fxRate: null,
        owedToAccountType: null,
        owedToAccountId: null,
        owedCurrencyId: null,
        owedToCurrencyId: null,
        owedToCurrencyFxRate: null,
        owedCurrencyFxRate: null,
        owedTransferAmount: null,
        owedToTransferAmount: null,
        transferFxRate: 1,
        transactionDescription: null,
        transactionDetail: null,
        transferTypeName:"MoneyTransfer",
      },

      customerSearch: [],
      personnelSearch: [],
      owedCustomerSearchQuery: null,
      owedToCustomerSearchQuery: null,
      owedPersonnelSearchQuery: null,
      owedToPersonnelSearchQuery: null,
      owedCustomerSearchQueryResult: [],
      owedPersonnelSearchQueryResult: [],
      owedToCustomerSearchQueryResult: [],
      owedToPersonnelSearchQueryResult: [],

      owedCustomerAccountList: [],
      owedAccountCompanyList: [],
      owedToCustomerAccountList: [],
      owedToAccountCompanyList: [],
    };
  },

  created: async function() {
    if (this.$route.params != null && this.$route.name == "MoneyTransferByCustomerId" && this.$route.params.customerId > 0) {
      let customerId = this.$route.params.customerId;
      this.moneyTransferModel.owedCustomerId = customerId;
      this.moneyTransferModel.owedToCustomerId = customerId;

      this.moneyTransferModel.owedAccountType = customerId;
      this.moneyTransferModel.owedToAccountType = customerId;

      this.moneyTransferModel.owedCustomerSearchQuery = customerId;
      this.moneyTransferModel.owedToCustomerSearchQuery = customerId;

      this.moneyTransferModel.owedAccountType = "Customer";
      this.moneyTransferModel.owedToAccountType = "Customer";

      this.owedCustomerSearchQuery = customerId;
      this.owedToCustomerSearchQuery = customerId;

      this.owedCustomerSearchQueryResult = await repository.getWithParam("Customer/search", "searchQuery=" + "CustomerId=" + this.owedCustomerSearchQuery).then((r) => r.list);
      this.owedToCustomerSearchQueryResult = await repository.getWithParam("Customer/search", "searchQuery=" + "CustomerId=" + this.owedToCustomerSearchQuery).then((r) => r.list);

      this.owedCustomerAccountList = await repository.postEntity("Accounting/GetAccount", { CustomerId: this.moneyTransferModel.owedCustomerId }).then((r) => r.list);
      this.owedToCustomerAccountList = await repository.postEntity("Accounting/GetAccount", { CustomerId: this.moneyTransferModel.owedToCustomerId }).then((r) => r.list);

      // this.moneyTransferModel.owedCustomerId = customerId;
      // this.moneyTransferModel.owedToCustomerId = customerId;

      // this.moneyTransferModel.owedCustomerId = customerId;
      // this.moneyTransferModel.owedToCustomerId = customerId;

      // this.moneyTransferModel.owedCustomerId = customerId;
      // this.moneyTransferModel.owedToCustomerId = customerId;

      // this.moneyTransferModel.owedCustomerId = customerId;
      // this.moneyTransferModel.owedToCustomerId = customerId;

      // this.moneyTransferModel.owedCustomerId = customerId;
      // this.moneyTransferModel.owedToCustomerId = customerId;
    }

    Promise.all([this.getUsers(), this.getCurrencies(), this.getAccountCompanyTypeList()]);
  },
  methods: {
    getCurrencies: async function() {
      this.moneyCurrencyOptions = await repository.getAll("Accounting/getCurrencies").then((r) => r.list);
    },
    createTransaction: async function() {
      if (this.moneyTransferModel.owedAccountType == this.moneyTransferModel.owedToAccountType && this.moneyTransferModel.owedAccountId == this.moneyTransferModel.owedToAccountId) {
        let resultConfirm = await this.$swal.fire({
          icon: "error",
          title: "Aynı hesaba transfer yapılamaz",
          //text: "",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet",
          cancelButtonText: "Hayır",
        });
        return;
      }

      let resultConfirm = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz? Para transferi hemen gerçekleşecektir.",
        //text: "Para transferi hemen gerçekleşecektir.",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm.isConfirmed) {
        this.moneyTransferModel.transactionDetail = document.getElementById("transactionDetail").innerText;
        this.$vs.loading();
        await repository.postEntity("Accounting/CreateMoneyTransfer", this.moneyTransferModel);
        this.$vs.loading.close();

        await this.$swal.fire({
          icon: "success",
          title: "Para transfer işlemi başarılı.",
          //text: "Devam etmek istediğinize emin misiniz?",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "Hayır",
        });

        this.moneyTransferModel = {
          owedCustomerId: null,
          owedToCustomerId: null,
          owedAccountType: null,
          owedAccountId: null,
          currencyId: null,
          fxRate: null,
          owedToAccountType: null,
          owedToAccountId: null,
          owedCurrencyId: null,
          owedToCurrencyId: null,
          owedToCurrencyFxRate: null,
          owedCurrencyFxRate: null,
          owedTransferAmount: null,
          owedToTransferAmount: null,
          transferFxRate: 1,
          transactionDescription: null,
          transactionDetail: null,
          transferTypeName:"MoneyTransfer",
        };
        this.customerSearch = null;
        this.personnelSearch = null;
        this.owedCustomerSearchQuery = null;
        this.owedToCustomerSearchQuery = null;
        this.owedPersonnelSearchQuery = null;
        this.owedToPersonnelSearchQuery = null;
        this.owedCustomerSearchQueryResult = [];
        this.owedPersonnelSearchQueryResult = [];
        this.owedToCustomerSearchQueryResult = [];
        this.owedToPersonnelSearchQueryResult = [];
        this.owedCustomerAccountList = [];
        this.owedAccountCompanyList = [];
        this.owedToCustomerAccountList = [];
        this.owedToAccountCompanyList = [];
      }
    },

    delayedSearch: async function(searchType) {
      if (this.delayedSearchTimer) {
        clearTimeout(this.delayedSearchTimer);
        this.delayedSearchTimer = null;
      }
      this.delayedSearchTimer = setTimeout(async () => {
        if (searchType == "OwedCustomer") {
          if (this.owedCustomerSearchQuery && this.owedCustomerSearchQuery.length > 2) {
            this.owedCustomerSearchQueryResult = await repository.getWithParam("Customer/search", "searchQuery=" + this.owedCustomerSearchQuery + "&pageSize=100").then((r) => r.list);
          }
        }
        if (searchType == "OwedToCustomer") {
          if (this.owedToCustomerSearchQuery && this.owedToCustomerSearchQuery.length > 2) {
            this.owedToCustomerSearchQueryResult = await repository.getWithParam("Customer/search", "searchQuery=" + this.owedToCustomerSearchQuery + "&pageSize=100").then((r) => r.list);
          }
        }
        if (searchType == "OwedPersonnel") {
          if (this.owedPersonnelSearchQuery && this.owedPersonnelSearchQuery.length > 3) {
            this.owedPersonnelSearchQueryResult = await repository.postEntity("HumanResource/GetUser", { UserName: this.owedPersonnelSearchQuery }).then((r) => r.list);
          }
        }
        if (searchType == "OwedToPersonnel") {
          if (this.owedToPersonnelSearchQuery && this.owedToPersonnelSearchQuery.length > 3) {
            this.owedToPersonnelSearchQueryResult = await repository.postEntity("HumanResource/GetUser", { UserName: this.owedToPersonnelSearchQuery }).then((r) => r.list);
          }
        }
      }, 500);
    },

    searchPersonnel: async function() {
      this.personnelSearch = await repository.getWithParam("HumanResource/GetUser", "searchQuery=" + this.searchQuery).then((r) => r.list);

      return this.personnelSearch;
    },

    getSelectedAccount: async function(transferSide) {
      if (transferSide == "OwedCustomer") {
        this.owedCustomerAccountList = await repository.postEntity("Accounting/GetAccount", { CustomerId: this.moneyTransferModel.owedCustomerId }).then((r) => r.list);
      } else if (transferSide == "OwedToCustomer") {
        this.owedToCustomerAccountList = await repository.postEntity("Accounting/GetAccount", { CustomerId: this.moneyTransferModel.owedToCustomerId }).then((r) => r.list);
      } else if (transferSide == "OwedPersonnel") {
        //NotAccountCorporationType: "EXPENSE",-------------->Bu şimdilik kaldırıldı ERP geçişinden sonra aktif olacak.
        this.owedAccountCompanyList = await repository.postEntity("Accounting/GetCompanyAccount", { UserId: this.moneyTransferModel.owedUserId, NotDescription: "DELETED" }).then((r) => r.list);
      } else if (transferSide == "OwedToPersonnel") {
        //NotAccountCorporationType: "EXPENSE",-------------->Bu şimdilik kaldırıldı ERP geçişinden sonra aktif olacak.
        //, accountCompanyTypeId: 89
        this.owedToAccountCompanyList = await repository.postEntity("Accounting/GetCompanyAccount", { UserId: this.moneyTransferModel.owedToUserId, NotDescription: "DELETED" }).then((r) => r.list);
      }
    },

    getItemListAfterRadioSelection: async function(e) {

    },

    RefreshFxRate: async function() {
      this.moneyTransferModel.owedCurrencyFxRate = this.moneyCurrencyOptions.filter((r) => r.id == this.moneyTransferModel.owedCurrencyId).map((obj) => obj.value)[0];
      this.moneyTransferModel.owedToCurrencyFxRate = this.moneyCurrencyOptions.filter((r) => r.id == this.moneyTransferModel.owedToCurrencyId).map((obj) => obj.value)[0];
      this.moneyTransferModel.transferFxRate = parseFloat(this.moneyTransferModel.owedCurrencyFxRate / this.moneyTransferModel.owedToCurrencyFxRate);

      this.moneyTransferModel.owedToTransferAmount = parseFloat(this.moneyTransferModel.transferFxRate * this.moneyTransferModel.owedTransferAmount).toFixed(2);
    },

    getAccountCompanyTypeList: async function() {
      this.accountCompanyTypeList = await repository.postEntity("Accounting/GetAccountCompanyType", {}).then((r) => r.list);
    },

    CheckReturnAmount: async function() {
      if (parseInt(this.saleOrderListForReturn[0].selectedSaleOrderLine.totalAmount) < this.customerModel.returnAmount) {
        let resultConfirm = await this.$swal.fire({
          icon: "error",
          // title: `Sipariş adedi ` + this.saleOrderListForReturn[0].selectedSaleOrderLine.quantity + " kadardır." + " Bu miktardan daha fazla iade yapamazsınız.",
          text: `Sipariş adedi ` + this.saleOrderListForReturn[0].selectedSaleOrderLine.totalAmount + " kadardır." + " Bu miktardan daha fazla iade yapamazsınız.",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet",
          cancelButtonText: "Hayır",
        });
        this.customerModel.returnAmount = 0;
        this.customerModel.amount = 0;
        return;
      }

      console.log(this.saleOrderListForReturn[0].selectedSaleOrderLine);
      this.customerModel.amount = (this.saleOrderListForReturn[0].selectedSaleOrderLine.totalCost * this.customerModel.returnAmount) / this.saleOrderListForReturn[0].selectedSaleOrderLine.totalAmount;
    },

    save: async function() {
      await repository.postEntity("Accounting/CreateMoneyTransfer", this.moneyTransferModel);
    },

    getUsers: async function() {
      this.personnelList = await repository.getAll("User/getUserList").then((r) => r.list);
    },
  },
};
</script>
<style lang="scss">
.card-bg {

  border-radius: 0.5rem;
  display: block;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: all 0.3s ease-in-out;
}
</style>
